import { RootLayout } from '@porotutu/react/components/RootLayout/RootLayout'
import { type NavGroup, Sidebar } from '@porotutu/react/components/Sidebar/Sidebar'
import { Building2Icon, HistoryIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { REALMS } from '@/features/vocabulary'
import { useSession, useSignOut } from '@/session'

export function Layout({ children }: { children: ReactNode }) {
  const { t } = useSession()
  const signOut = useSignOut()

  const groups: NavGroup[] = [
    {
      key: 'identity',
      title: t('layouts.main.nav_groups.identity'),
      links: REALMS.map((realm) => ({
        to: `/users/${realm}`,
        label: t(`adm.users.tabs.${realm}`),
        icon: UsersIcon,
      })),
    },
    {
      key: 'oversight',
      title: t('layouts.main.nav_groups.oversight'),
      links: [
        { to: '/organizations', label: t('adm.organizations.nav'), icon: Building2Icon },
        { to: '/roles', label: t('adm.roles.nav'), icon: ShieldCheckIcon },
        { to: '/audit', label: t('adm.audit.nav'), icon: HistoryIcon },
      ],
    },
  ]

  return (
    <RootLayout
      sidebar={(onNavigate) => (
        <Sidebar
          groups={groups}
          home="/organizations"
          mark="A"
          fallback={t('adm.brand')}
          onSignOut={signOut}
          onNavigate={onNavigate}
        />
      )}
      profilePath="/profile"
      profileLabelKey="adm.profile.show.title"
    >
      {children}
    </RootLayout>
  )
}
